import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useAdRefresh = () => {
  const location = useLocation();

  useEffect(() => {
    const delay = setTimeout(() => {
      try {
        if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
          window.adsbygoogle.push({});
        }
      } catch (err) {
        console.error("Ad refresh failed", err);
      }
    }, 1000);

    return () => clearTimeout(delay);
  }, [location.pathname]);
};

export default useAdRefresh;


